<template>

    <div class="behavior-report-feedback-report-header">
        <table class="table">
            <tr>
                <td>Parent Signature:</td>
                <td style="width: 50%" class="behavior-report-signature"></td>
                <td>Date:</td>
                <td style="width: 25%" class="behavior-report-signature"></td>
            </tr>
        </table>
    </div>

</template>

<script>

    import Vue from 'vue'

    export default Vue.extend({
        name: "BehaviorReportFeedbackReportHeader",
    })

</script>

<style lang="scss">
    .behavior-report-signature {
        padding-bottom: 10px;
        border-bottom: solid 1px #000;
    }
</style>